const listAttributes = [
  'course',
  'lessonId',
  'active',
  'lessonGroup',
  'label',
  'lessonType',
  'isTimesheeted',
  'homeworkRequired',
  'sortOrder',
] as const;

const getAttributes = [...listAttributes, 'permissions', 'duration', 'quiz'] as const;

const updateAttributes = [
  'label',
  'lessonType',
  'lessonGroup',
  'isTimesheeted',
  'homeworkRequired',
  'active',
  'quiz',
] as const;

export const LessonTemplateAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};
